import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.stats-hero__mobile-stats-splide' ).length ) {
        $( '.stats-hero__mobile-stats-splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            drag: false,
            autoWidth: true,
            gap: '1.25rem',
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
            mediaQuery: 'min',
            breakpoints: {
              1024: {
                destroy: true,
              },
            },
          } );

          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'stats-hero', COMPONENT );
} )( app );
